<template>
  <div class="login-page">
    <!-- 顶部品牌栏 -->
    <div class="top-bar">
      <span class="brand-text">慧小娱自助</span>
    </div>

    <!-- 主卡片 -->
    <div class="login-card">
      <!-- 左侧视觉区 -->
      <div class="left-panel">
        <div class="left-content">
          <img src="@/assets/images/logo7.png" class="logo-img" alt="logo" />
          <h2 class="slogan">科技赋能，自助更自在</h2>
          <p class="feature-desc">智能化设备管控 · 高效运营管理</p>
        </div>
      </div>

      <!-- 右侧登录区 -->
      <div class="right-panel">
        <div class="form-wrapper">
          <h1 class="form-title">IoT设备管控平台</h1>
          <p class="form-welcome">欢迎回来，请登录您的账号</p>

          <div class="input-group">
            <label>用户名</label>
            <el-input v-model="userInfo.loginAccount" placeholder="请输入用户名" size="large"
              :prefix-icon="UserFilled" clearable />
          </div>

          <div class="input-group">
            <label>密码</label>
            <el-input v-model="userInfo.password" placeholder="请输入密码" size="large" show-password
              :prefix-icon="Lock" @keyup.enter="onSubmit" />
          </div>

          <el-button type="primary" round class="login-btn" @click="onSubmit" :loading="isloading">
            {{ isloading ? '登录中...' : '登 录' }}
          </el-button>

          <p class="copyright">深圳悦联智通科技有限公司版权所有 · 粤ICP备2025388669号</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router';
import { UserFilled, Lock } from '@element-plus/icons-vue'
import { setUserInf } from "@/shard/login-info-manager";
import { authApi } from "@/api/auth-api";
import CryptoJS from 'crypto-js';

const userInfo = reactive({
  loginAccount: '',
  password: ''
});

const isloading = ref(false);
const router = useRouter();

const onSubmit = () => {
  isloading.value = true;
  userInfo.password = CryptoJS.SHA256(userInfo.password).toString();
  authApi.login(userInfo)
    .then((response) => {
      if (response.data && response.data.errorCode === "00000") {
        setUserInf(response.data.result.accessToken)
        router.push("/main");
      } else {
        ElMessage.error(`登录失败【${response.data.errorMessage}(${response.data.errorCode})】`)
      }
    })
    .finally(() => {
      isloading.value = false;
    })
};

onMounted(() => {
  window.addEventListener('keydown', function (event) {
    if (event.key === 'Enter') {
      onSubmit();
    }
  })
})
</script>

<style scoped>
/* ========== 页面容器 ========== */
.login-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e8edf5 0%, #f0f2f5 50%, #e3eaf5 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* ========== 顶部品牌 ========== */
.top-bar {
  width: 75%;
  max-width: 1000px;
  min-width: 760px;
  margin-bottom: 24px;
  text-align: left;
}

.brand-text {
  font-size: 22px;
  font-weight: 500;
  color: #333399;
  letter-spacing: 2px;
}

/* ========== 登录卡片 ========== */
.login-card {
  display: grid;
  grid-template-columns: 0.85fr 1fr;
  width: 75%;
  max-width: 1000px;
  min-width: 760px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(51, 51, 153, 0.12), 0 4px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* ========== 左侧视觉区 ========== */
.left-panel {
  background: linear-gradient(160deg, #2d2d8a 0%, #333399 40%, #4a4ab8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 30px;
}

.left-content {
  text-align: center;
  color: #fff;
}

.logo-img {
  width: 140px;
  margin-bottom: 28px;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.2));
}

.slogan {
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 12px 0;
  letter-spacing: 2px;
  color: #fff;
}

.feature-desc {
  font-size: 14px;
  opacity: 0.75;
  margin: 0;
  letter-spacing: 1px;
}

/* ========== 右侧表单区 ========== */
.right-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 55px;
}

.form-wrapper {
  width: 100%;
  max-width: 380px;
}

.form-title {
  font-size: 28px;
  font-weight: 700;
  color: #303133;
  margin: 0 0 8px 0;
  letter-spacing: 0.5px;
}

.form-welcome {
  font-size: 14px;
  color: #909399;
  margin: 0 0 36px 0;
}

/* ========== 输入区 ========== */
.input-group {
  margin-bottom: 22px;
}

.input-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 8px;
}

.input-group :deep(.el-input__wrapper) {
  border-radius: 10px;
  box-shadow: 0 0 0 1px #e4e7ed inset;
  transition: all 0.2s ease;
}

.input-group :deep(.el-input__wrapper:hover) {
  box-shadow: 0 0 0 1px #c0c4cc inset;
}

.input-group :deep(.el-input.is-focus .el-input__wrapper) {
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.25) inset;
}

/* ========== 登录按钮 ========== */
.login-btn {
  width: 100%;
  height: 48px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 6px;
  border-radius: 10px;
  margin-top: 8px;
  background: #409eff;
  border: none;
  transition: all 0.3s ease;
}

.login-btn:hover {
  background: #337ecc;
  transform: translateY(-1px);
  box-shadow: 0 4px 14px rgba(64, 158, 255, 0.4);
}

.login-btn:active {
  transform: translateY(0);
}

/* ========== 版权信息 ========== */
.copyright {
  font-size: 12px;
  color: #b0b8c4;
  text-align: center;
  margin: 40px 0 0 0;
  letter-spacing: 0.5px;
}

/* ========== 响应式适配 ========== */
@media (max-width: 820px) {
  .login-card {
    grid-template-columns: 1fr;
    min-width: auto;
    width: 92%;
  }

  .left-panel {
    padding: 30px 20px;
  }

  .logo-img {
    width: 100px;
    margin-bottom: 16px;
  }

  .slogan {
    font-size: 17px;
  }

  .right-panel {
    padding: 30px 28px;
  }
}
</style>
